/**
 * 离线车留档
 */
import { useEffect, useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Col, Form, Input, Select, Tag } from 'antd';
import DatePicker from '@/components/datePicker';
import styles from '@/styles/pageContent.module.scss';
import CommonTable from '@/components/commonTable';
import { useTable } from '@/utils/useTable';
import ExportButton from '@/components/exportButton';
import dayjs from 'dayjs';
import { tagListRequest } from '@/service/tagManage';
import { TagCategoryEnum } from '@/constants/tagManage';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import { dataDepartmentListRequestPath, getChannelListRequest } from '@/service/dataDepartment';
import QuickSelectRangePicker from '@/components/quickSelectRangePicker';
import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

interface TotalTableProps {
  requestMethod: any; // 请求方法
}

const { RangePicker } = DatePicker;
const OfflineCarRecord = (props: TotalTableProps) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useState({
    type: 2,
  }); // 搜索相关的参数
  const { requestMethod } = props;
  const { page, limit, loading, data, totalCount, onPageChange, getData } = useTable({
    requestFunc: requestMethod,
    initPageSize: 40,
    searchParams,
  });
  const [vehicleState, setVehicleState] = useState<any>([]); // 车辆状态
  const [channelData, setChannelData] = useState([]); // 渠道
  const [filterList, setFilterList] = useState<any>(['source','masterProblem','slaveProblem','monitorType','occurrenceDays','hmw','binocular','millage','followUpType']); // 筛选选项
  const refreshaaa = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6512" width="20" height="20"><path d="M981.314663 554.296783a681.276879 681.276879 0 0 1-46.986468 152.746388q-105.706098 230.734238-360.983096 242.19829a593.06288 593.06288 0 0 1-228.689008-33.853939v-1.022615l-31.808709 79.979258a55.759429 55.759429 0 0 1-20.506122 22.551352 40.043451 40.043451 0 0 1-21.04434 5.382184 51.076928 51.076928 0 0 1-19.483507-5.382184 95.210839 95.210839 0 0 1-13.347817-7.158305 52.314831 52.314831 0 0 1-5.382184-4.628679L71.671707 731.908862a57.427906 57.427906 0 0 1-7.158305-21.528737 46.932646 46.932646 0 0 1 1.022615-17.438277 35.952991 35.952991 0 0 1 7.158305-13.347816 74.435608 74.435608 0 0 1 10.279972-10.279972 60.495751 60.495751 0 0 1 11.248765-7.373593 50.431066 50.431066 0 0 1 8.18092-3.606063 6.189512 6.189512 0 0 0 3.067845-1.776121l281.003839-74.866183a91.497132 91.497132 0 0 1 35.899168-2.583448 122.337047 122.337047 0 0 1 22.174599 6.404799 21.528737 21.528737 0 0 1 12.325202 12.325202 76.157907 76.157907 0 0 1 4.628679 14.854829 47.63233 47.63233 0 0 1 0 14.370431 55.167388 55.167388 0 0 1-2.04523 10.764369 10.764368 10.764368 0 0 0-1.022615 3.606063l-32.831324 79.979258a677.50935 677.50935 0 0 0 164.264262 39.505232q77.395809 7.696523 131.809692-3.606063a358.507291 358.507291 0 0 0 101.023598-36.921784 381.27393 381.27393 0 0 0 73.951211-50.753997 352.64071 352.64071 0 0 0 48.708767-55.382676 410.391547 410.391547 0 0 0 26.910921-41.550462c3.767529-7.481236 6.673908-13.616926 8.719139-18.460892zM40.885614 449.667121a685.69027 685.69027 0 0 1 63.563595-176.427998q118.0313-212.273346 374.330913-207.160271a571.803252 571.803252 0 0 1 207.160271 39.989629l33.853939-78.956643A75.619688 75.619688 0 0 1 735.187378 9.189165a37.67529 37.67529 0 0 1 15.393047-8.234742 42.303968 42.303968 0 0 1 14.854829-0.538219 47.578509 47.578509 0 0 1 13.347817 3.606064 102.907362 102.907362 0 0 1 11.302586 6.13569 49.569917 49.569917 0 0 1 6.673909 4.628678l3.067845 3.067845 154.84544 276.913379a81.970666 81.970666 0 0 1 6.13569 22.712817 46.986468 46.986468 0 0 1-1.022615 17.438277 32.293105 32.293105 0 0 1-7.696523 13.347817 69.322533 69.322533 0 0 1-10.764369 9.741753 92.142994 92.142994 0 0 1-11.302587 6.673909l-8.18092 4.09046a7.104483 7.104483 0 0 1-3.067845 1.022615l-283.049068 67.546412a112.003254 112.003254 0 0 1-46.125319-1.022615c-11.571696-3.390776-19.160576-8.019454-22.551352-13.832214a41.173709 41.173709 0 0 1-5.382184-21.04434 97.256069 97.256069 0 0 1 1.291724-17.438277 24.381295 24.381295 0 0 1 3.067845-8.234742L600.632773 296.81309a663.730958 663.730958 0 0 0-164.102797-43.057474q-77.987849-9.203535-131.809692 0a348.227319 348.227319 0 0 0-101.292707 33.853938 368.571976 368.571976 0 0 0-75.350579 49.246986 383.31916 383.31916 0 0 0-50.269601 54.360061 408.507783 408.507783 0 0 0-28.740863 41.012244A113.025869 113.025869 0 0 0 40.885614 449.667121z m0 0" fill="#467CFD" p-id="6513"></path></svg>
  )
  const RefreshIcon = (props: Partial<CustomIconComponentProps>) => (
    <Icon component={refreshaaa} {...props} />
  );

  useEffect(() => {
    getVehicleState()
    getChannelData()
  }, []);

  // 获取渠道
  const getChannelData = async() => {
    const res = await getChannelListRequest();
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { name } = item;
      tags.push({ label: name, value: name });
    });
    setChannelData(tags)
  }

  // 处理搜索参数
  const operateSearchParams = (params: any, isExport?: boolean) => {
    const newSearchParams:any = {...params}
    if (params.time) {
      newSearchParams.beginDate = dayjs(params.time[0]).format('YYYY-MM-DD');
      newSearchParams.endDate = dayjs(params.time[1]).format('YYYY-MM-DD');
      delete newSearchParams.time
    }
    if (isExport) {
      newSearchParams.export = true;
    }
    return newSearchParams;
  }

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = operateSearchParams(values);
    newSearchParams.type = 2
    setSearchParams(newSearchParams);
  };

  // 获取导出的参数
  const getExportParams = () => {
    const values = form.getFieldsValue();
    values.type = 2
    values.ignoreColumns = filterList
    return operateSearchParams(values, true);
  }

  // 筛选列
  const changeFilter = (value:any) => {
    const filter: any[] = []
    columns.map((item:any) => {
      filter.push(item.dataIndex)
    })
    const noFilter: any[] = []
    filter.map((itemm:any) => {
      const aaa = value.indexOf(itemm)
      if (aaa == -1) {
        noFilter.push(itemm)
      }
      setFilterList(noFilter.concat(['source','masterProblem','slaveProblem','monitorType','occurrenceDays','hmw','binocular','millage','followUpType']))
    })
  }

  // 表格列显示
  const columns: any = [
    {
      title: '序号',
      dataIndex: 'id',
      width: 50,
      ellipsis: { showTitle: false },
    },
    {
      title: '车辆状态',
      dataIndex: 'state',
      width: 100,
      ellipsis: { showTitle: false },
    },
    {
      title: '创建时间',
      dataIndex: 'createdAt',
      width: 160,
      ellipsis: { showTitle: false },
      render: (value: string) => value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : value,
    },
    {
      title: '创建人',
      dataIndex: 'creator',
      width: 80,
      ellipsis: { showTitle: false },
    },
    {
      title: '锁定状态',
      dataIndex: 'lockState',
      width: 80,
      ellipsis: { showTitle: false },
      render: (value: any) => {return (value == 1 ? <Tag color="success">已锁定</Tag> : <Tag color="error">未锁定</Tag>)}
    },
    // {
    //   title: '设备SN',
    //   dataIndex: 'sn',
    //   width: 130,
    //   ellipsis: { showTitle: false },
    // },
    {
      title: '车架号',
      dataIndex: 'frameNumber',
      width: 150,
      ellipsis: { showTitle: false },
    },
    {
      title: '渠道',
      dataIndex: 'channel',
      width: 90,
      ellipsis: { showTitle: false },
    },
    {
      title: '公司',
      dataIndex: 'company',
      width: 150,
      ellipsis: { showTitle: false },
    },
    {
      title: '车辆情况说明',
      dataIndex: 'suggest',
      width: 150,
      ellipsis: { showTitle: false },
      render: (value:any,item:any) => (
        <RenderEllipsisColumn text={value} />
      )
    },
    {
      title: 'aeb离线天数',
      dataIndex: 'offlineDays',
      width: 80,
      ellipsis: { showTitle: false },
      render: (value:any,item:any) =>{ 
      return (
          value === -1 ? '设备未上线': value
      )
    } 
    },
    {
      title: 'adas离线天数',
      dataIndex: 'adasOfflineDays',
      width: 80,
      ellipsis: { showTitle: false },
      render: (value:any,item:any) =>{ 
        return (
            value === -1 ? '设备未上线': value
        )
      } 
    },
    {
      title: '是否为问题车',
      dataIndex: 'problemCarFlag',
      width: 110,
      ellipsis: { showTitle: false },
      render: (value: any) => {
        return (
          value == 0 ? <Tag>否</Tag> : value == 1 ? <Tag>是</Tag> : value
        )
      }
    },
    {
      title: '负责人',
      dataIndex: 'linkman1',
      width: 80,
      ellipsis: { showTitle: false },
    },
    {
      title: '负责人电话',
      dataIndex: 'tel1',
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: '司机',
      dataIndex: 'linkman2',
      width: 80,
      ellipsis: { showTitle: false },
    },
    {
      title: '司机电话',
      dataIndex: 'tel2',
      width: 130,
      ellipsis: { showTitle: false },
    },
    // {
    //   title: '客服处理时间',
    //   dataIndex: 'customerRecordTime',
    //   width: 160,
    //   ellipsis: { showTitle: false },
    //   render: (value: string) => value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : value,
    // },
    // {
    //   title: '客服处理内容',
    //   dataIndex: 'customerRecordContent',
    //   width: 150,
    //   ellipsis: { showTitle: false },
    //   render: (value: string) => <RenderEllipsisColumn text={value} />,
    // },
    // {
    //   title: '客服处理状态',
    //   dataIndex: 'taskState',
    //   width: 140,
    //   ellipsis: { showTitle: false },
    //   render: (value: any) => {
    //     return (
    //       value == 0 ? <Tag>未处理</Tag> : value == 1 ? <Tag>处理中-待呼叫</Tag> : value == 2 ? <Tag>智能体-已呼叫</Tag> : value == 3 ? <Tag>处理中-已创建工单</Tag> : value == 4 ? <Tag>处理中-已派工单</Tag> : value == 5 ? <Tag>处理中-已完成现场处理</Tag> : value == 6 ? <Tag>处理完成</Tag> : value == 7 ? <Tag>已退回</Tag>: value == 8 ? <Tag>已关闭</Tag> : value == 9 ? <Tag>智能体-待处理</Tag> : value == 10 ? <Tag>协助车辆</Tag> : null
    //     )
    //   }
    // },
    // {
    //   title: '维保时间',
    //   dataIndex: 'maintainedTime',
    //   width: 160,
    //   ellipsis: { showTitle: false },
    //   render: (value: string) => value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : value,
    // },
    // {
    //   title: '维保内容',
    //   dataIndex: 'maintainedContent',
    //   width: 150,
    //   ellipsis: { showTitle: false },
    //   render: (value: any) => <div className={styles.tableTagColumn}>
    //     {value ? JSON.parse(value)?.map((item: any, index:any) => <Tag key={index}>{item}</Tag>) : null}
    //   </div>,
    // },
    {
      title: '最后修改人',
      dataIndex: 'updatePerson',
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: '最后修改时间',
      dataIndex: 'updateAt',
      width: 130,
      ellipsis: { showTitle: false },
    },
    {
      title: '车牌号',
      dataIndex: 'plateNumber',
      width: 85,
      fixed: 'right' as 'right',
      ellipsis: { showTitle: false },
      render: (value:any,item:any,index:any) => (
        <div style={{color:'#1890ff', cursor:'pointer'}} onClick={() => skipCarDiagnosis(value)}>{value}</div>
      )
    },

  ];

  // 获取车辆状态
  const getVehicleState = async () => {
    const res = await tagListRequest({
      tagSorts: [TagCategoryEnum.offVehicleSource],
    });
    const tags: any = [];
    (res.data?.data || []).forEach((item: any) => {
      const { title } = item;
      tags.push({ label: title, value: title });
    });
    setVehicleState(tags);
  }

  // 点击车牌跳转车辆诊断
  const skipCarDiagnosis = (value:any) => {
    dispatch({
      type: 'addTab',
      payload: {
        tab: '车辆诊断',
        key: '/car-admin/car-diagnosis',
        params: { plateNumber:value,beginDate: dayjs().subtract(7, 'day').format('YYYY-MM-DD'), endDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD') }
      }
    })
  }

  // 清空搜索
  const clearSearch = () => {
    form.setFieldsValue({
      sn:null,
      plateNumber:null,
      frameNumber:null,
      company:null,
      tel:null,
      state:null,
      time:null,
    })
  }
  //客服处理状态
  const stateData = [
    { label: '未处理', value: 0 },
    { label: '处理中-待呼叫', value: 1 },
    { label: '智能体-已呼叫', value: 2 },
    { label: '智能体-待处理', value: 9 },
    { label: '协助车辆', value: 10 },
    { label: '处理中-已创建工单', value: 3 },
    { label: '处理中-已派工单', value: 4 },
    { label: '处理中-已完成现场处理', value: 5 },
    { label: '处理完成', value: 6 },
    { label: '已退回', value: 7 },
    { label: '已关闭', value: 8 },
  ];
  
  return (
    <Fragment>
      <Form onFinish={onSearch} form={form}>
        <div style={{display:'flex'}}>
        <Col span={4}>
            <Form.Item label="设备SN" name="sn">
              <Input placeholder="请输入设备SN" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="车牌号" name="plateNumber">
              <Input placeholder="请输入车牌号" allowClear onChange={(e) => {const newV = e.target.value.replace(/\s+/g, ''); form.setFieldValue('plateNumber', newV)}}/>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="车架号" name="frameNumber">
              <Input placeholder="请输入车架号" allowClear onChange={(e) => {const newV = e.target.value.replace(/\s+/g, ''); form.setFieldValue('frameNumber', newV)}}/>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="渠道" name="channels">
              <Select 
                placeholder="请选择渠道" 
                mode="multiple"
                options={channelData} 
                allowClear 
                showArrow 
                showSearch 
                optionFilterProp="label"  
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="公司" name="company">
              <Input placeholder="请输入公司" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item label="手机号" name="tel">
              <Input placeholder="请输入手机号" allowClear />
            </Form.Item>
          </Col>
        </div>
        <div style={{display:'flex'}}>
          <Col span={4}>
            <Form.Item label="车辆状态" name="state">
            <Select 
              placeholder="请选择车辆状态" 
              mode="multiple"
              options={vehicleState} 
              allowClear 
              showArrow 
              showSearch 
              optionFilterProp="label"  
            />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="客服处理状态" name="taskState">
            <Select
                options={stateData} 
                placeholder="请选择客服处理状态"
                showSearch
                mode="multiple"
                showArrow
                maxTagCount="responsive"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="日期"
              name="time"
            >
              <QuickSelectRangePicker style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <div onClick={clearSearch} style={{height:'100%', width:'30px'}}><RefreshIcon style={{margin:'5px',cursor:'pointer'}} /></div>
          <Col span={4}>
            <Form.Item>
              <div className={styles.searchBox}>
                <Button type="primary" htmlType="submit">搜索</Button>
                <ExportButton 
                  url={dataDepartmentListRequestPath}
                  fileName='离线车留档'
                  getParamsFunc={getExportParams}
                  requestMethod="GET"
                  permissionKey='/car-admin/data-department/export'
                />
              </div>
            </Form.Item>
          </Col>
        </div>
      </Form>
      <CommonTable
        size='small'
        rowKey="id"
        columns={columns}
        dataSource={data}
        changeFilter={changeFilter}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange,
        }}
        bordered
        loading={loading}
      />
    </Fragment>
  )
}

export default OfflineCarRecord;